<template>
    
    <scroll-page :pull-reload="true">

      
    <list-absence :group_id="group_id"/>

     </scroll-page>
  
</template>

<script>

import { mapState } from 'vuex';

import ScrollPage from '../components/ScrollPage.vue';
//import ButtonAction from '../components/buttons/ButtonAction.vue';
import { USER_LEVEL } from '../settings/USER_LEVEL';
import ListAbsence from '../components/absence/ListAbsence.vue';


export default {
  name: 'group-absence-page',
  data:function(){
    return {
      group_id:this.$route.params.id,
    }
  },
  methods:{
  },
  computed:{
     ...mapState([
       'groups','appSettings','group',
       ]),
       computeUserAccess(){
         if (this.appSettings.user_level==USER_LEVEL.PARENT){
           return true;
         }
         if (this.appSettings.user_level==USER_LEVEL.TEACHER){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.STUDENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.ADMIN){
           return false;
         }
         return false;
       }
  },
  components:{
    ScrollPage,
    //ButtonAction,
    ListAbsence,
  },
  created(){
  },
  mounted(){
  },
  beforeDestroy(){
  }
  
  
}




</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
